__turbopack_context__.v({
  "footnote": "footnote-module-scss-module__SSlfOa__footnote",
});
